import React, { FunctionComponent, ReactElement, ReactNode } from 'react'
import Provider from '@sport1/react-elements/UniversalProvider'
import PlatformHelper from '@sport1/react-elements/PlatformHelper'
import darkTheme from '../../themes/DarkTheme'
import lightTheme from '../../themes/LightTheme'
import fontelloConfig from '../../themes/fonts/fontello/config.json'
import webLightTheme from '../../themes/web/WebLightTheme'
import webDarkTheme from '../../themes/web/WebDarkTheme'
import webMediathekDarkTheme from '../../themes/web/WebMediathekDarkTheme'

export type ThemeTypes = 'light' | 'dark' | 'webLight' | 'webDark' | 'webMediathekDark'

interface UniversalProviderPropsInterface {
    children: ReactElement | ReactNode
    themeName: ThemeTypes
    isNextJS?: boolean
}

const UniversalProvider: FunctionComponent<UniversalProviderPropsInterface> = ({
    themeName,
    isNextJS,
    children,
}): ReactElement => {
    let activeTheme = lightTheme

    if (themeName === 'webLight') {
        activeTheme = webLightTheme
    } else if (themeName === 'webDark') {
        activeTheme = webDarkTheme
    } else if (themeName === 'webMediathekDark') {
        activeTheme = webMediathekDarkTheme
    } else if (themeName === 'dark') {
        activeTheme = darkTheme
    }

    PlatformHelper.isNextJS = !!isNextJS

    return (
        <Provider theme={activeTheme} fontelloConfig={fontelloConfig}>
            {children}
        </Provider>
    )
}

export default UniversalProvider
